import { ReactComponent as BOTA } from "../../IndustryIcons/Botanical Gardens.svg";
import { ReactComponent as DIST } from "../../IndustryIcons/Distributor.svg";
import { ReactComponent as EMPL } from "../../IndustryIcons/Employee.svg";
import { ReactComponent as FARM } from "../../IndustryIcons/Farm.svg";
import { ReactComponent as GOLF } from "../../IndustryIcons/Golf.svg";
import { ReactComponent as GOVE } from "../../IndustryIcons/Government.svg";
import { ReactComponent as INDU } from "../../IndustryIcons/Industrial.svg";
import { ReactComponent as TREE } from "../../IndustryIcons/TreeCare.svg";
import { ReactComponent as ONET } from "../../IndustryIcons/One Time.svg";
// import { ReactComponent as SCHO } from "../IndustryIcons/School.svg";
import { ReactComponent as NONP } from "../../IndustryIcons/NonProfit.svg";
import { ReactComponent as SPOR } from "../../IndustryIcons/SportsField.svg";

import { ReactComponent as MUNI } from "../../IndustryIcons/Municipal.svg";

import React, {useEffect, useState} from "react";
import {QuestionMarkCircleIcon} from "@heroicons/react/24/outline";

const IndustryIcons = ({ selectedIndustry, size, color }) => {
    
    const [SelectedComponent, setSelectedComponent] = useState(null); // This will store the component itself
    const sharedClassName = `${size ? `${size}` : 'size-11'} ${color ? `${color}` : 'text-green-600'}`; // You can also move this to Tailwind config if reused widely
    
    useEffect(() => {
        const industryMap = {
            "BOTANICAL": {component: BOTA},
            "DISTRIB": {component: DIST},
            "EMPLOYEE": {component: EMPL},
            "FARM": {component: FARM},
            "GOLF": {component: GOLF},
            "GOVERNMENT": {component: GOVE},
            "INDUSTRIAL": {component: INDU},
            "LAWNTREE": {component: TREE},
            "MRSALE": {component: ONET},
            "MUNICIPAL": {component: MUNI},
            "Non-Profit": {component: NONP},
            "SPORTFLD": {component: SPOR}
        };
        
        const industryData = industryMap[selectedIndustry];
        
        if (industryData) {
            setSelectedComponent(industryData.component);
        } else {
            setSelectedComponent(QuestionMarkCircleIcon);
        }
        
    }, [selectedIndustry]);
    
    
    return (
        <div className="w-fit h-fit">
            {SelectedComponent ? (
                <SelectedComponent className={sharedClassName} />
            ) : (
                <QuestionMarkCircleIcon className={sharedClassName} />
            )}
        </div>
    );
}

export default IndustryIcons;
